Backbone = require 'backbone'
Backbone.$ = $

class EmailFormUSDateTimeInputView extends Backbone.View
  tagName: 'li'

  events:
    'change .date_time_input' : 'validateEmailForm'
    'change .time_input_us'   : 'validateEmailForm'

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @isInputFieldEmpty = true
    @dateElementSelector = ".date_time_input"
    @timeElementSelector = ".time_input_us"
    @template = @options.template
    @model = @options.model
    @label = @model.label
    @isInputCompulsory = @model.required is true or @model.required is "true"

  render: ->
    @$el.html(toHtml(@template, @toHash()))
    @$el.find(@dateElementSelector).datetimepicker @getDatePickerOptions()
    @$el.find(@timeElementSelector).datetimepicker @getTimePickerOptions()

  getDatePickerOptions: ()->
    options =
      format              : 'm/d/Y'
      timepicker          : false
      closeOnDateSelect   : true

  getTimePickerOptions: ()->
    options =
      step       : 30
      format     : 'g:i A'
      datepicker : false
      formatTime : 'g:i A'

  toHash: ->
    date_time_input_template: true
    label: @label
    required: @isInputCompulsory

  getDateInputHtmlElement: ->
    @$el.find(@dateElementSelector)

  getTimeInputHtmlElement: ->
    @$el.find(@timeElementSelector)

  isInputGiven: ->
    @getDateInputHtmlElement().val().trim().length > 0 and
    @getTimeInputHtmlElement().val().trim().length > 0

  readInput: ->
    date = @getDateInputHtmlElement().val().trim()
    time = @getTimeInputHtmlElement().val().trim()
    "#{date} #{time}"

  isInputValid: ->
    true

  validateEmailForm: ->
    if @isInputCompulsory && ((@isInputFieldEmpty && @isInputGiven()) || !(@isInputFieldEmpty || @isInputGiven()))
      @isInputFieldEmpty = !@isInputGiven()
      @options.validateEmailForm()

  populateInput: (data)->
    if @isInputGiven()
      inputData = @readInput()
      data.description += "\n\n #{@label} : #{inputData}"

module.exports = EmailFormUSDateTimeInputView
